import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import RemittanceStatusHistoryStore from "./CommentsStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./CommentsButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import Box from "../../../ui_components/Box/Box";
import Width from "../../../ui_components/common/enums/Width";
import Alignment from "../../../ui_components/common/enums/Alignment";
import CommentsButtonProperties from './CommentsButtonProperties';
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import CommentIcon from '@mui/icons-material/Comment';
import ShowComments from '../../Info/ShowComments/ShowComments';
import { useUserContext } from '../../../contexts/UserContext';
import Link from '../../../ui_components/Link/Link';

const CommentsButton: React.FC<CommentsButtonProperties> = ({
                                                                          showIcon = true,
                                                                          showText = true,
                                                                          disabled,
                                                                          className = '',
                                                                          deliveryOrderType,
                                                                          deliveryOrderId,
                                                                          deliveryOrderNumber,
                                                                          rounded = false,
                                                                          isLinkText,
                                                                          size = ButtonSize.DEFAULT,
                                                                          type = ButtonType.DEFAULT,
                                                                          onClose
                                                                      }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userContext = useUserContext();
    const store = new RemittanceStatusHistoryStore(commonContext, deliveryOrderType, deliveryOrderId);

    var commentAdded = false;

    const handleOnclick = async () => {
        await store.openModal();
    }

    const handleNewCommentOnclick = async (comment: string) => {
        const result = await store.addComment(comment);
        if (result) {
            commentAdded = true;
        }
    }

    const onCloseModal = () => {
        store.closeModal();
        if (commentAdded && onClose) {
            onClose();
        }
        commentAdded = false;
    }

    const text = 'Comentarios'
    const Icon = CommentIcon;
    const Btn = () => {
        if (isLinkText) {
            return <Link text={'Comentario'} onClick={handleOnclick} startIcon={CommentIcon}></Link>
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <SidePanel title={text} onClose={onCloseModal} open={store.isModalOpen}
                       className={classes.modal_container}>
                    <div className={classes.history_container}>
                        <Box
                            width={Width.FULL_WIDTH}
                            justifyContent={Alignment.START}>
                            {i18n.translate("REMITTANCE_ORDER_NUMBER")}: <strong className={classes.margin_left_4}>{deliveryOrderNumber}</strong>
                        </Box>
                        <div className={classes.body}>
                            {<ShowComments
                                onNewComment={handleNewCommentOnclick}
                                comments={store.moneyDeliveryOrderComments} loguedUserId={userContext.currentUser() ? userContext.currentUser()!!.id : ''}/>}
                        </div>
                    </div>
                </SidePanel>
                <Btn/>
            </>
        )}
    </Observer>
}

export default CommentsButton;
